import { Box, Typography } from "@mui/material"
import { AutocompleteMulti } from "components/AutocompleteMulti/AutocompleteMulti"
import { CriteriaCatalog, Examination } from "graphql/types"
import { useStoreActions, useStoreState } from "hooks/storeHooks"
import { CriteriaCatalogContent } from "pages/AdminUI/AdminCriteriaCatalog/CriteriaCatalogContent"
import { useEffect, useMemo } from "react"

type CriteriaCatalogCardProps = {
  examination: Examination
  // eslint-disable-next-line no-unused-vars
  setExamination: React.Dispatch<React.SetStateAction<Examination | undefined>>
}

export const CriteriaCatalogCard = ({ examination, setExamination }: CriteriaCatalogCardProps) => {
  const { criteriaCatalogs } = useStoreState((state) => state)
  const { fetchCriteriaCatalogs } = useStoreActions((actions) => actions)

  useEffect(() => {
    fetchCriteriaCatalogs({ fresh: false })
  }, [fetchCriteriaCatalogs])

  const filteredTextBlocks = useMemo(
    () =>
      criteriaCatalogs.filter(
        (crit) =>
          (crit.examinationConfig.length === 0 ||
            crit.examinationConfig.includes(examination.examinationConfig.id)) &&
          (crit.norm.length === 0 || crit.norm.includes(examination.norm.id))
      ),
    [criteriaCatalogs, examination.examinationConfig.id, examination.norm.id]
  )

  const handleSetCriteriaCatalog = (value: CriteriaCatalog[]) => {
    if (examination) {
      setExamination({
        ...examination,
        passFailCriteria: value,
      })
    }
  }

  const handleChangeCriteriaCatalog = (criteriaCatalog: CriteriaCatalog): void => {
    if (examination) {
      setExamination({
        ...examination,
        passFailCriteria: examination.passFailCriteria.map((c) =>
          c.id === criteriaCatalog.id ? criteriaCatalog : c
        ),
      })
    }
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography>Pass/Fail-Kriterienkataloge</Typography>

      <AutocompleteMulti
        options={filteredTextBlocks}
        value={examination.passFailCriteria}
        onChange={(_, value) => handleSetCriteriaCatalog(value)}
        label="Parameter hinzufügen"
        fullWidth
      />

      <Box>
        {examination.passFailCriteria.map((criteriaCatalog) => (
          <CriteriaCatalogContent
            key={criteriaCatalog.id}
            criteriaCatalog={criteriaCatalog}
            onUpdateCriteriaCatalog={handleChangeCriteriaCatalog}
            operatingModes={examination.operatingModes}
          />
        ))}
      </Box>
    </Box>
  )
}
